import { login } from '@cronos-app/api';
import type { currentWallet } from '@cronos-app/wallet';

export const signAndLogin = async (
  walletAddress: string,
  provider: ReturnType<(typeof currentWallet)['useProvider']>,
): Promise<boolean> => {
  if (!walletAddress) throw new Error('Wallet address is undefined');
  const timestamp = Date.now();
  const message = getMessage(walletAddress, timestamp);
  const signature = await (await provider?.getSigner())?.signMessage(message);
  if (!signature) throw new Error('Signature is missing');
  const { success } = await login({
    walletAddress,
    signature,
    timestamp,
  });
  return success;
};

const getMessage = (walletAddress: string, timestamp: number): string => {
  return `Welcome to Agentfun!\n\nPlease sign to let us verify that you are the owner of this address: ${walletAddress.toLowerCase()}\n\nYour authentication status will reset after 30 days.\ntimestamp: ${timestamp}`;
};
